import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

const Register = () => {
  const [loading, setLoading] = useState(false);
  const { register: registerUser } = useAuth();
  const navigate = useNavigate();
  
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm();

  const password = watch('password');

  const onSubmit = async (data) => {
    setLoading(true);
    
    try {
      const result = await registerUser(data.email, data.password, data.fullName);
      
      if (result.success) {
        toast.success('¡Cuenta creada exitosamente!');
        navigate('/extractor');
      } else {
        toast.error(result.error);
      }
    } catch (error) {
      toast.error('Error inesperado al crear la cuenta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg d-flex align-items-center justify-content-center min-vh-100">
      <div className="auth-card shadow-lg rounded-4 p-4" style={{ background: 'rgba(255,255,255,0.97)', minWidth: 340, maxWidth: 400 }}>
        <div className="text-center mb-4">
          <i className="bi bi-file-pdf display-4 text-primary mb-2"></i>
          <h1 className="fw-bold mb-1" style={{ letterSpacing: 1 }}>DataExtractor</h1>
          <div className="text-muted mb-2" style={{ fontSize: '1.1rem' }}>Crea tu cuenta</div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group mb-3">
            <label htmlFor="fullName" className="form-label">Nombre Completo</label>
            <input
              type="text"
              id="fullName"
              className="form-control"
              {...register('fullName', {
                required: 'El nombre completo es requerido',
                minLength: {
                  value: 2,
                  message: 'El nombre debe tener al menos 2 caracteres'
                }
              })}
              placeholder="Tu nombre completo"
            />
            {errors.fullName && (
              <div className="error-message">{errors.fullName.message}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="email" className="form-label">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              className="form-control"
              {...register('email', {
                required: 'El correo electrónico es requerido',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Formato de correo inválido'
                }
              })}
              placeholder="tu@email.com"
            />
            {errors.email && (
              <div className="error-message">{errors.email.message}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="password" className="form-label">Contraseña</label>
            <input
              type="password"
              id="password"
              className="form-control"
              {...register('password', {
                required: 'La contraseña es requerida',
                minLength: {
                  value: 6,
                  message: 'La contraseña debe tener al menos 6 caracteres'
                }
              })}
              placeholder="Crea una contraseña"
            />
            {errors.password && (
              <div className="error-message">{errors.password.message}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="confirmPassword" className="form-label">Confirmar Contraseña</label>
            <input
              type="password"
              id="confirmPassword"
              className="form-control"
              {...register('confirmPassword', {
                required: 'Confirma tu contraseña',
                validate: value =>
                  value === password || 'Las contraseñas no coinciden'
              })}
              placeholder="Confirma tu contraseña"
            />
            {errors.confirmPassword && (
              <div className="error-message">{errors.confirmPassword.message}</div>
            )}
          </div>
          <button 
            type="submit" 
            className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 mb-3"
            disabled={loading}
            style={{ fontWeight: 600, fontSize: '1.1rem' }}
          >
            <i className="bi bi-person-plus"></i>
            {loading ? 'Creando cuenta...' : 'Crear Cuenta'}
          </button>
        </form>
        <div className="auth-links text-center mt-3">
          <div className="divider small">
            ¿Ya tienes cuenta? <Link to="/login">Inicia sesión aquí</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
